// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Wft56","top":"styles_top__1DneS"};